import { useQuery } from '@tanstack/react-query';

import { Template, TemplateInstance } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../../constants/signatureBasePath';
import { listSignatureTemplates } from '../../requests/listSignatureTemplates';

export const useListSignatureTemplates = (
  envelopeId: string,
  instances: TemplateInstance[],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const instanceTemplateIds = instances.map((i) => i.template_id);

  const { data, ...rest } = useQuery<
    NonPaginatedResponse<Template[]> | undefined
  >({
    queryKey: [
      SIGNATURE_BASE_PATH,
      'templates',
      envelopeId,
      instanceTemplateIds,
    ],
    queryFn: () =>
      listSignatureTemplates(constructGet, envelopeId, {
        include: 'roles.fields',
        ...instanceTemplateIds.reduce<Record<string, string>>(
          (acc, id, index) => ({ ...acc, [`id[${index}]`]: id }),
          {},
        ),
      }),
    enabled: !!envelopeId && instances.length > 0,
    ...options,
  });

  return { ...unwrapNonPaginatedResponseDataAs(data, 'templates'), ...rest };
};
